<template>
    <b-progress class="progress" size="is-small" :value="progressValue"></b-progress>
</template>

<script>
import {
  mapGetters,
} from 'vuex';

export default {
  name: 'MobileProgressBar',
  computed: {
    ...mapGetters(['areaProgress']),
    progressValue() {
      return this.areaProgress;
    },
  },
};
</script>

<style lang="scss" scoped>
  @media screen and (orientation:portrait) {
    .progress {
      z-index: 2;
      position: sticky;
      position: -webkit-sticky;
      top: 106px;
    }
  }
  /* Landscape */
  @media screen and (orientation:landscape) {
    .progress {
      z-index: 2;
      position: sticky;
      position: -webkit-sticky;
      top: 106px;
    }
  }

</style>
